module.exports = __webpack_public_path__ + "static/media/expert-anna.b558f068.png";